module.exports = __webpack_public_path__ + "img/Partner.26f53a3.jpg";